import http from './http';

export interface Treatment {
  id: string;
  userId: string;
  taskId: number;
  treatmentType?: string;
  purpose?: string;
  facilityName?: string;
  location?: string;
  phone?: string;
  insurance?: string;
  cost?: string;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateTreatmentData {
  taskId: number;
  treatmentType?: string;
  purpose?: string;
  facilityName?: string;
  location?: string;
  phone?: string;
  insurance?: string;
  cost?: string;
  notes?: string;
}

export interface UpdateTreatmentData extends Partial<CreateTreatmentData> {}

class TreatmentsService {
  async getTreatments(taskId: number): Promise<Treatment[]> {
    const res = await http.get(`/api/treatments?taskId=${taskId}`);
    return res.data;
  }

  async getAllTreatments(targetUserId?: string): Promise<Treatment[]> {
    const params = targetUserId ? `?targetUserId=${targetUserId}` : '';
    const res = await http.get(`/api/treatments${params}`);
    return res.data;
  }

  async getTreatmentById(id: string): Promise<Treatment> {
    const res = await http.get(`/api/treatments/${id}`);
    return res.data;
  }

  async createTreatment(data: CreateTreatmentData): Promise<{ id: string }> {
    const res = await http.post('/api/treatments', data);
    return res.data;
  }

  async updateTreatment(id: string, data: UpdateTreatmentData): Promise<Treatment> {
    const res = await http.patch(`/api/treatments/${id}`, data);
    return res.data;
  }

  async deleteTreatment(id: string): Promise<void> {
    await http.delete(`/api/treatments/${id}`);
  }

  async lockTreatment(id: string): Promise<void> {
    await http.post(`/api/treatments/${id}/lock`);
  }

  async unlockTreatment(id: string, granteeEmails: string[]): Promise<void> {
    await http.post(`/api/treatments/${id}/unlock`, { granteeEmails });
  }

  async getTreatmentAccessGrants(id: string): Promise<any[]> {
    const res = await http.get(`/api/treatments/${id}/access-grants`);
    const result = res.data;
    return result.data || [];
  }
}

export const treatmentsService = new TreatmentsService();
























